/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { HTTP401NotAuthenticatedErrorResponse } from "../../models/hTTP401NotAuthenticatedErrorResponse.ts";

import type { HTTPValidationError } from "../../models/hTTPValidationError.ts";

import type { TrialCheckoutRequest } from "../../models/trialCheckoutRequest.ts";

import type { TrialCheckoutResponse } from "../../models/trialCheckoutResponse.ts";

import type { TrialStatusResponse } from "../../models/trialStatusResponse.ts";

import { customMutator } from "../../../mutators/custom-mutator.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getTrialsGetTrialStatusResponse200 = {
  data: TrialStatusResponse;
  status: 200;
};

export type getTrialsGetTrialStatusResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type getTrialsGetTrialStatusResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTrialsGetTrialStatusResponseSuccess =
  getTrialsGetTrialStatusResponse200 & {
    headers: Headers;
  };
export type getTrialsGetTrialStatusResponseError = (
  | getTrialsGetTrialStatusResponse401
  | getTrialsGetTrialStatusResponse422
) & {
  headers: Headers;
};

export type getTrialsGetTrialStatusResponse =
  | getTrialsGetTrialStatusResponseSuccess
  | getTrialsGetTrialStatusResponseError;

export const getGetTrialsGetTrialStatusUrl = () => {
  return `/api/credits/trial`;
};

/**
 * @summary Get Trial Status
 */
export const getTrialsGetTrialStatus = async (
  options?: RequestInit,
): Promise<getTrialsGetTrialStatusResponse> => {
  return customMutator<getTrialsGetTrialStatusResponse>(
    getGetTrialsGetTrialStatusUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTrialsGetTrialStatusQueryKey = () => {
  return [`/api/credits/trial`] as const;
};

export const getGetTrialsGetTrialStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTrialsGetTrialStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTrialsGetTrialStatus>>
  > = ({ signal }) => getTrialsGetTrialStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTrialsGetTrialStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrialsGetTrialStatus>>
>;
export type GetTrialsGetTrialStatusQueryError =
  | HTTP401NotAuthenticatedErrorResponse
  | HTTPValidationError;

export function useGetTrialsGetTrialStatus<
  TData = Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
          TError,
          Awaited<ReturnType<typeof getTrialsGetTrialStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrialsGetTrialStatus<
  TData = Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
          TError,
          Awaited<ReturnType<typeof getTrialsGetTrialStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTrialsGetTrialStatus<
  TData = Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Trial Status
 */

export function useGetTrialsGetTrialStatus<
  TData = Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTrialsGetTrialStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Trial Status
 */
export const prefetchGetTrialsGetTrialStatusQuery = async <
  TData = Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
  TError = HTTP401NotAuthenticatedErrorResponse | HTTPValidationError,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTrialsGetTrialStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customMutator>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetTrialsGetTrialStatusQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

export type postTrialsStartTrialCheckoutResponse200 = {
  data: TrialCheckoutResponse;
  status: 200;
};

export type postTrialsStartTrialCheckoutResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postTrialsStartTrialCheckoutResponse409 = {
  data: void;
  status: 409;
};

export type postTrialsStartTrialCheckoutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type postTrialsStartTrialCheckoutResponse502 = {
  data: void;
  status: 502;
};

export type postTrialsStartTrialCheckoutResponse503 = {
  data: void;
  status: 503;
};

export type postTrialsStartTrialCheckoutResponseSuccess =
  postTrialsStartTrialCheckoutResponse200 & {
    headers: Headers;
  };
export type postTrialsStartTrialCheckoutResponseError = (
  | postTrialsStartTrialCheckoutResponse401
  | postTrialsStartTrialCheckoutResponse409
  | postTrialsStartTrialCheckoutResponse422
  | postTrialsStartTrialCheckoutResponse502
  | postTrialsStartTrialCheckoutResponse503
) & {
  headers: Headers;
};

export type postTrialsStartTrialCheckoutResponse =
  | postTrialsStartTrialCheckoutResponseSuccess
  | postTrialsStartTrialCheckoutResponseError;

export const getPostTrialsStartTrialCheckoutUrl = () => {
  return `/api/credits/trial`;
};

/**
 * @summary Start Trial Checkout
 */
export const postTrialsStartTrialCheckout = async (
  trialCheckoutRequest: TrialCheckoutRequest,
  options?: RequestInit,
): Promise<postTrialsStartTrialCheckoutResponse> => {
  return customMutator<postTrialsStartTrialCheckoutResponse>(
    getPostTrialsStartTrialCheckoutUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(trialCheckoutRequest),
    },
  );
};

export const getPostTrialsStartTrialCheckoutMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTrialsStartTrialCheckout>>,
    TError,
    { data: TrialCheckoutRequest },
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTrialsStartTrialCheckout>>,
  TError,
  { data: TrialCheckoutRequest },
  TContext
> => {
  const mutationKey = ["postTrialsStartTrialCheckout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTrialsStartTrialCheckout>>,
    { data: TrialCheckoutRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postTrialsStartTrialCheckout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTrialsStartTrialCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTrialsStartTrialCheckout>>
>;
export type PostTrialsStartTrialCheckoutMutationBody = TrialCheckoutRequest;
export type PostTrialsStartTrialCheckoutMutationError =
  | HTTP401NotAuthenticatedErrorResponse
  | void
  | HTTPValidationError;

/**
 * @summary Start Trial Checkout
 */
export const usePostTrialsStartTrialCheckout = <
  TError = HTTP401NotAuthenticatedErrorResponse | void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTrialsStartTrialCheckout>>,
      TError,
      { data: TrialCheckoutRequest },
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTrialsStartTrialCheckout>>,
  TError,
  { data: TrialCheckoutRequest },
  TContext
> => {
  return useMutation(
    getPostTrialsStartTrialCheckoutMutationOptions(options),
    queryClient,
  );
};
export type postTrialsCancelTrialResponse200 = {
  data: TrialStatusResponse;
  status: 200;
};

export type postTrialsCancelTrialResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postTrialsCancelTrialResponse409 = {
  data: void;
  status: 409;
};

export type postTrialsCancelTrialResponse502 = {
  data: void;
  status: 502;
};

export type postTrialsCancelTrialResponseSuccess =
  postTrialsCancelTrialResponse200 & {
    headers: Headers;
  };
export type postTrialsCancelTrialResponseError = (
  | postTrialsCancelTrialResponse401
  | postTrialsCancelTrialResponse409
  | postTrialsCancelTrialResponse502
) & {
  headers: Headers;
};

export type postTrialsCancelTrialResponse =
  | postTrialsCancelTrialResponseSuccess
  | postTrialsCancelTrialResponseError;

export const getPostTrialsCancelTrialUrl = () => {
  return `/api/credits/trial/cancel`;
};

/**
 * @summary Cancel Trial
 */
export const postTrialsCancelTrial = async (
  options?: RequestInit,
): Promise<postTrialsCancelTrialResponse> => {
  return customMutator<postTrialsCancelTrialResponse>(
    getPostTrialsCancelTrialUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostTrialsCancelTrialMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTrialsCancelTrial>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTrialsCancelTrial>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postTrialsCancelTrial"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTrialsCancelTrial>>,
    void
  > = () => {
    return postTrialsCancelTrial(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTrialsCancelTrialMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTrialsCancelTrial>>
>;

export type PostTrialsCancelTrialMutationError =
  HTTP401NotAuthenticatedErrorResponse | void;

/**
 * @summary Cancel Trial
 */
export const usePostTrialsCancelTrial = <
  TError = HTTP401NotAuthenticatedErrorResponse | void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTrialsCancelTrial>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTrialsCancelTrial>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostTrialsCancelTrialMutationOptions(options),
    queryClient,
  );
};
export type postTrialsConfirmTrialResponse200 = {
  data: TrialStatusResponse;
  status: 200;
};

export type postTrialsConfirmTrialResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postTrialsConfirmTrialResponse409 = {
  data: void;
  status: 409;
};

export type postTrialsConfirmTrialResponse502 = {
  data: void;
  status: 502;
};

export type postTrialsConfirmTrialResponseSuccess =
  postTrialsConfirmTrialResponse200 & {
    headers: Headers;
  };
export type postTrialsConfirmTrialResponseError = (
  | postTrialsConfirmTrialResponse401
  | postTrialsConfirmTrialResponse409
  | postTrialsConfirmTrialResponse502
) & {
  headers: Headers;
};

export type postTrialsConfirmTrialResponse =
  | postTrialsConfirmTrialResponseSuccess
  | postTrialsConfirmTrialResponseError;

export const getPostTrialsConfirmTrialUrl = () => {
  return `/api/credits/trial/confirm`;
};

/**
 * @summary Confirm Trial
 */
export const postTrialsConfirmTrial = async (
  options?: RequestInit,
): Promise<postTrialsConfirmTrialResponse> => {
  return customMutator<postTrialsConfirmTrialResponse>(
    getPostTrialsConfirmTrialUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostTrialsConfirmTrialMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTrialsConfirmTrial>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTrialsConfirmTrial>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postTrialsConfirmTrial"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTrialsConfirmTrial>>,
    void
  > = () => {
    return postTrialsConfirmTrial(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTrialsConfirmTrialMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTrialsConfirmTrial>>
>;

export type PostTrialsConfirmTrialMutationError =
  HTTP401NotAuthenticatedErrorResponse | void;

/**
 * @summary Confirm Trial
 */
export const usePostTrialsConfirmTrial = <
  TError = HTTP401NotAuthenticatedErrorResponse | void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTrialsConfirmTrial>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTrialsConfirmTrial>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostTrialsConfirmTrialMutationOptions(options),
    queryClient,
  );
};
export type postTrialsResumeTrialResponse200 = {
  data: TrialStatusResponse;
  status: 200;
};

export type postTrialsResumeTrialResponse401 = {
  data: HTTP401NotAuthenticatedErrorResponse;
  status: 401;
};

export type postTrialsResumeTrialResponse409 = {
  data: void;
  status: 409;
};

export type postTrialsResumeTrialResponse502 = {
  data: void;
  status: 502;
};

export type postTrialsResumeTrialResponseSuccess =
  postTrialsResumeTrialResponse200 & {
    headers: Headers;
  };
export type postTrialsResumeTrialResponseError = (
  | postTrialsResumeTrialResponse401
  | postTrialsResumeTrialResponse409
  | postTrialsResumeTrialResponse502
) & {
  headers: Headers;
};

export type postTrialsResumeTrialResponse =
  | postTrialsResumeTrialResponseSuccess
  | postTrialsResumeTrialResponseError;

export const getPostTrialsResumeTrialUrl = () => {
  return `/api/credits/trial/resume`;
};

/**
 * @summary Resume Trial
 */
export const postTrialsResumeTrial = async (
  options?: RequestInit,
): Promise<postTrialsResumeTrialResponse> => {
  return customMutator<postTrialsResumeTrialResponse>(
    getPostTrialsResumeTrialUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPostTrialsResumeTrialMutationOptions = <
  TError = HTTP401NotAuthenticatedErrorResponse | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTrialsResumeTrial>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTrialsResumeTrial>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postTrialsResumeTrial"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTrialsResumeTrial>>,
    void
  > = () => {
    return postTrialsResumeTrial(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTrialsResumeTrialMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTrialsResumeTrial>>
>;

export type PostTrialsResumeTrialMutationError =
  HTTP401NotAuthenticatedErrorResponse | void;

/**
 * @summary Resume Trial
 */
export const usePostTrialsResumeTrial = <
  TError = HTTP401NotAuthenticatedErrorResponse | void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postTrialsResumeTrial>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postTrialsResumeTrial>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostTrialsResumeTrialMutationOptions(options),
    queryClient,
  );
};
